import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { tokenNotExpired } from 'angular2-jwt';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private route: ActivatedRoute) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (route.params && route.params['jwt']) {
            localStorage.setItem('jwt', route.params['jwt']);
        } else if (route.firstChild) {
            if(route.firstChild.params['jwt']){
                localStorage.setItem('jwt', route.firstChild.params['jwt']);
            } else if(route.firstChild.firstChild){
                if(route.firstChild.firstChild.params['jwt']){
                    localStorage.setItem('jwt', route.firstChild.firstChild.params['jwt']);
                }
            }
        }

        // Check to see if a user has a valid JWT
        if (tokenNotExpired('jwt')) {
            // If they do, return true and allow the user to load the home component
            console.log('token exist');
            return true;
        }
        // If not, they redirect them to the login page
        console.log('no token');
        this.router.navigate(['public/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/system/shared/auth.guard.ts